<template>

  <div class="group" :ref="refs[builder.interior.fieldName + 'Group']">

    <div class="group-header" :id="`${builder.interior.fieldName}Title`">
      <div class="group-title">Choose your interior.</div>
      <div class="group-help">The below options are based on the measurements you have provided.</div>
    </div>

    <Selector
      :key=builder.interior.fieldName
      :field-name=builder.interior.fieldName
      :display-type=builder.interior.displayType
      :options=builder.interior.options
      :selected=builder.currentItem.specs[builder.interior.fieldName]
      options-source="interiorOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>
  
  <div class="group" :ref="refs[builder.requireDoors.fieldName + 'Group']" id="requireDoors">
    
    <div class="group-header">
      <div class="group-title">Do you require doors and tracks?</div>
    </div>

    <Selector
      :key=builder.requireDoors.fieldName
      :field-name=builder.requireDoors.fieldName
      :display-type=builder.requireDoors.displayType
      :options=builder.requireDoors.options
      :selected=builder.currentItem.specs[builder.requireDoors.fieldName]
      options-source="requireDoorsOptions"
      scope="specs"
      @select-option="select"
    ></Selector>
    
  </div>
  
  <div class="group" :ref="refs['panelsGroup']" :class="{ 's_hidden' : !builder.currentItem.specs.requireDoors }">

    <div class="group-header">
      <div class="group-title">Choose your standard door panels</div>
    </div>

    <div class="subgroup" v-for="n in builder.currentItem.data.doorsVal" :key="n" :ref="refs[builder['panel' + n].fieldName + 'Group']" :id="`panel${n}Id`">

      <div class="subgroup-header" :id="`${builder.panels.fieldName}${n}Title`">
        <div class="subgroup-title"><span class="visually-hidden">Choose your standard door panels: </span>Door {{ n }}</div>
      </div>

      <div class="subgroup-main">

        <Selector
          :key="`${builder['panel' + n].fieldName}`"
          :field-name="`${builder['panel' + n].fieldName}`"
          :display-type=builder.panels.displayType
          :options=builder.panels.options
          :selected="`${builder.currentItem.specs[builder['panel' + n].fieldName]}`"
          options-source="panelsOptions"
          scope="specs"
          @select-option="select"
        ></Selector>

      </div>

    </div>

  </div>

  <div class="group" :ref="refs[builder.frames.fieldName + 'Group']" :class="{'s_hidden' : !builder.currentItem.specs.requireDoors}">

    <div class="group-header" :id="`${builder.frames.fieldName}Title`">
      <div class="group-title">Choose your door frames and tracks.</div>
    </div>

    <Selector
      :key=builder.frames.fieldName
      :field-name=builder.frames.fieldName
      :display-type=builder.frames.displayType
      :options=builder.frames.options
      :selected=builder.currentItem.specs[builder.frames.fieldName]
      options-source="framesOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>

  <div class="group" :ref="refs[builder.hardware.fieldName + 'Group']" :class="{'s_hidden' : !builder.currentItem.specs.requireInternals}">

    <div class="group-header" :id="`${builder.hardware.fieldName}Title`">
      <div class="group-title">Choose your hardware options.</div>
    </div>

    <Selector
      :key=builder.hardware.fieldName
      :field-name=builder.hardware.fieldName
      :display-type=builder.hardware.displayType
      :options=builder.hardware.options
      :selected=builder.currentItem.specs[builder.hardware.fieldName]
      options-source="hardwareOptions"
      scope="specs"
      @select-option="select"
    ></Selector>

  </div>
  
</template>

<script setup>
  
import { computed, ref, onMounted } from 'vue'

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

function select(prop, opt) {
  builder.setCurrentItemSpec(prop, opt['id']);
}

// init refs
let refHandles = [
  builder.interior.fieldName + 'Group',
  builder.requireDoors.fieldName + 'Group',
  builder.frames.fieldName + 'Group',
  builder.hardware.fieldName + 'Group',
];
if (builder.currentItem.data.doorsVal >= 1) refHandles.push(builder.panel1.fieldName + 'Group');
if (builder.currentItem.data.doorsVal >= 2) refHandles.push(builder.panel2.fieldName + 'Group');
if (builder.currentItem.data.doorsVal >= 3) refHandles.push(builder.panel3.fieldName + 'Group');
if (builder.currentItem.data.doorsVal >= 4) refHandles.push(builder.panel4.fieldName + 'Group');
const refs = _.chain(refHandles).keyBy().mapValues(ref).value();
refHandles.forEach(item => {
  builder.refs[item] = refs[item];
});
</script>